/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AppAllDevicesRouteImport } from './routes/_app/all-devices'
import { Route as AppAllSharingRouteImport } from './routes/_app/all-sharing'
import { Route as AppAuditRouteImport } from './routes/_app/audit'
import { Route as AppDeviceContentRouteImport } from './routes/_app/device-content'
import { Route as AppDevicesRouteImport } from './routes/_app/devices'
import { Route as AppInboxRouteImport } from './routes/_app/inbox'
import { Route as AppKeysRouteImport } from './routes/_app/keys'
import { Route as AppLegalDocumentsRouteImport } from './routes/_app/legal-documents'
import { Route as AppNotificationsRouteImport } from './routes/_app/notifications'
import { Route as AppOrgsRouteImport } from './routes/_app/orgs'
import { Route as AppOverviewRouteImport } from './routes/_app/overview'
import { Route as AppPeopleRouteImport } from './routes/_app/people'
import { Route as AppPolicyRouteImport } from './routes/_app/policy'
import { Route as AppSharingRouteImport } from './routes/_app/sharing'
import { Route as AppStaffRolesRouteImport } from './routes/_app/staff-roles'
import { Route as AppTrailRouteImport } from './routes/_app/trail'
import { Route as AppYourLegalDocumentsRouteImport } from './routes/_app/your-legal-documents'
import { Route as AppLegalDocumentsDocumentIdRouteImport } from './routes/_app/legal-documents_.$documentId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAllDevicesRoute = AppAllDevicesRouteImport.update({
  id: '/all-devices',
  path: '/all-devices',
  getParentRoute: () => AppRoute,
} as any)
const AppAllSharingRoute = AppAllSharingRouteImport.update({
  id: '/all-sharing',
  path: '/all-sharing',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditRoute = AppAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppRoute,
} as any)
const AppDeviceContentRoute = AppDeviceContentRouteImport.update({
  id: '/device-content',
  path: '/device-content',
  getParentRoute: () => AppRoute,
} as any)
const AppDevicesRoute = AppDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxRoute = AppInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppRoute,
} as any)
const AppKeysRoute = AppKeysRouteImport.update({
  id: '/keys',
  path: '/keys',
  getParentRoute: () => AppRoute,
} as any)
const AppLegalDocumentsRoute = AppLegalDocumentsRouteImport.update({
  id: '/legal-documents',
  path: '/legal-documents',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppOrgsRoute = AppOrgsRouteImport.update({
  id: '/orgs',
  path: '/orgs',
  getParentRoute: () => AppRoute,
} as any)
const AppOverviewRoute = AppOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AppRoute,
} as any)
const AppPeopleRoute = AppPeopleRouteImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => AppRoute,
} as any)
const AppPolicyRoute = AppPolicyRouteImport.update({
  id: '/policy',
  path: '/policy',
  getParentRoute: () => AppRoute,
} as any)
const AppSharingRoute = AppSharingRouteImport.update({
  id: '/sharing',
  path: '/sharing',
  getParentRoute: () => AppRoute,
} as any)
const AppStaffRolesRoute = AppStaffRolesRouteImport.update({
  id: '/staff-roles',
  path: '/staff-roles',
  getParentRoute: () => AppRoute,
} as any)
const AppTrailRoute = AppTrailRouteImport.update({
  id: '/trail',
  path: '/trail',
  getParentRoute: () => AppRoute,
} as any)
const AppYourLegalDocumentsRoute = AppYourLegalDocumentsRouteImport.update({
  id: '/your-legal-documents',
  path: '/your-legal-documents',
  getParentRoute: () => AppRoute,
} as any)
const AppLegalDocumentsDocumentIdRoute =
  AppLegalDocumentsDocumentIdRouteImport.update({
    id: '/legal-documents_/$documentId',
    path: '/legal-documents/$documentId',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/invite': typeof InviteRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/all-devices': typeof AppAllDevicesRoute
  '/all-sharing': typeof AppAllSharingRoute
  '/audit': typeof AppAuditRoute
  '/device-content': typeof AppDeviceContentRoute
  '/devices': typeof AppDevicesRoute
  '/inbox': typeof AppInboxRoute
  '/keys': typeof AppKeysRoute
  '/legal-documents': typeof AppLegalDocumentsRoute
  '/notifications': typeof AppNotificationsRoute
  '/orgs': typeof AppOrgsRoute
  '/overview': typeof AppOverviewRoute
  '/people': typeof AppPeopleRoute
  '/policy': typeof AppPolicyRoute
  '/sharing': typeof AppSharingRoute
  '/staff-roles': typeof AppStaffRolesRoute
  '/trail': typeof AppTrailRoute
  '/your-legal-documents': typeof AppYourLegalDocumentsRoute
  '/legal-documents/$documentId': typeof AppLegalDocumentsDocumentIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/invite': typeof InviteRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/all-devices': typeof AppAllDevicesRoute
  '/all-sharing': typeof AppAllSharingRoute
  '/audit': typeof AppAuditRoute
  '/device-content': typeof AppDeviceContentRoute
  '/devices': typeof AppDevicesRoute
  '/inbox': typeof AppInboxRoute
  '/keys': typeof AppKeysRoute
  '/legal-documents': typeof AppLegalDocumentsRoute
  '/notifications': typeof AppNotificationsRoute
  '/orgs': typeof AppOrgsRoute
  '/overview': typeof AppOverviewRoute
  '/people': typeof AppPeopleRoute
  '/policy': typeof AppPolicyRoute
  '/sharing': typeof AppSharingRoute
  '/staff-roles': typeof AppStaffRolesRoute
  '/trail': typeof AppTrailRoute
  '/your-legal-documents': typeof AppYourLegalDocumentsRoute
  '/legal-documents/$documentId': typeof AppLegalDocumentsDocumentIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/invite': typeof InviteRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/_app/all-devices': typeof AppAllDevicesRoute
  '/_app/all-sharing': typeof AppAllSharingRoute
  '/_app/audit': typeof AppAuditRoute
  '/_app/device-content': typeof AppDeviceContentRoute
  '/_app/devices': typeof AppDevicesRoute
  '/_app/inbox': typeof AppInboxRoute
  '/_app/keys': typeof AppKeysRoute
  '/_app/legal-documents': typeof AppLegalDocumentsRoute
  '/_app/notifications': typeof AppNotificationsRoute
  '/_app/orgs': typeof AppOrgsRoute
  '/_app/overview': typeof AppOverviewRoute
  '/_app/people': typeof AppPeopleRoute
  '/_app/policy': typeof AppPolicyRoute
  '/_app/sharing': typeof AppSharingRoute
  '/_app/staff-roles': typeof AppStaffRolesRoute
  '/_app/trail': typeof AppTrailRoute
  '/_app/your-legal-documents': typeof AppYourLegalDocumentsRoute
  '/_app/legal-documents_/$documentId': typeof AppLegalDocumentsDocumentIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/invite'
    | '/reset-password'
    | '/sign-in'
    | '/all-devices'
    | '/all-sharing'
    | '/audit'
    | '/device-content'
    | '/devices'
    | '/inbox'
    | '/keys'
    | '/legal-documents'
    | '/notifications'
    | '/orgs'
    | '/overview'
    | '/people'
    | '/policy'
    | '/sharing'
    | '/staff-roles'
    | '/trail'
    | '/your-legal-documents'
    | '/legal-documents/$documentId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/invite'
    | '/reset-password'
    | '/sign-in'
    | '/all-devices'
    | '/all-sharing'
    | '/audit'
    | '/device-content'
    | '/devices'
    | '/inbox'
    | '/keys'
    | '/legal-documents'
    | '/notifications'
    | '/orgs'
    | '/overview'
    | '/people'
    | '/policy'
    | '/sharing'
    | '/staff-roles'
    | '/trail'
    | '/your-legal-documents'
    | '/legal-documents/$documentId'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/forgot-password'
    | '/invite'
    | '/reset-password'
    | '/sign-in'
    | '/_app/all-devices'
    | '/_app/all-sharing'
    | '/_app/audit'
    | '/_app/device-content'
    | '/_app/devices'
    | '/_app/inbox'
    | '/_app/keys'
    | '/_app/legal-documents'
    | '/_app/notifications'
    | '/_app/orgs'
    | '/_app/overview'
    | '/_app/people'
    | '/_app/policy'
    | '/_app/sharing'
    | '/_app/staff-roles'
    | '/_app/trail'
    | '/_app/your-legal-documents'
    | '/_app/legal-documents_/$documentId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  InviteRoute: typeof InviteRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignInRoute: typeof SignInRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/all-devices': {
      id: '/_app/all-devices'
      path: '/all-devices'
      fullPath: '/all-devices'
      preLoaderRoute: typeof AppAllDevicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/all-sharing': {
      id: '/_app/all-sharing'
      path: '/all-sharing'
      fullPath: '/all-sharing'
      preLoaderRoute: typeof AppAllSharingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audit': {
      id: '/_app/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AppAuditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/device-content': {
      id: '/_app/device-content'
      path: '/device-content'
      fullPath: '/device-content'
      preLoaderRoute: typeof AppDeviceContentRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/devices': {
      id: '/_app/devices'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof AppDevicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox': {
      id: '/_app/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AppInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/keys': {
      id: '/_app/keys'
      path: '/keys'
      fullPath: '/keys'
      preLoaderRoute: typeof AppKeysRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/legal-documents': {
      id: '/_app/legal-documents'
      path: '/legal-documents'
      fullPath: '/legal-documents'
      preLoaderRoute: typeof AppLegalDocumentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orgs': {
      id: '/_app/orgs'
      path: '/orgs'
      fullPath: '/orgs'
      preLoaderRoute: typeof AppOrgsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/overview': {
      id: '/_app/overview'
      path: '/overview'
      fullPath: '/overview'
      preLoaderRoute: typeof AppOverviewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/people': {
      id: '/_app/people'
      path: '/people'
      fullPath: '/people'
      preLoaderRoute: typeof AppPeopleRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/policy': {
      id: '/_app/policy'
      path: '/policy'
      fullPath: '/policy'
      preLoaderRoute: typeof AppPolicyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sharing': {
      id: '/_app/sharing'
      path: '/sharing'
      fullPath: '/sharing'
      preLoaderRoute: typeof AppSharingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/staff-roles': {
      id: '/_app/staff-roles'
      path: '/staff-roles'
      fullPath: '/staff-roles'
      preLoaderRoute: typeof AppStaffRolesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/trail': {
      id: '/_app/trail'
      path: '/trail'
      fullPath: '/trail'
      preLoaderRoute: typeof AppTrailRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/your-legal-documents': {
      id: '/_app/your-legal-documents'
      path: '/your-legal-documents'
      fullPath: '/your-legal-documents'
      preLoaderRoute: typeof AppYourLegalDocumentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/legal-documents_/$documentId': {
      id: '/_app/legal-documents_/$documentId'
      path: '/legal-documents/$documentId'
      fullPath: '/legal-documents/$documentId'
      preLoaderRoute: typeof AppLegalDocumentsDocumentIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAllDevicesRoute: typeof AppAllDevicesRoute
  AppAllSharingRoute: typeof AppAllSharingRoute
  AppAuditRoute: typeof AppAuditRoute
  AppDeviceContentRoute: typeof AppDeviceContentRoute
  AppDevicesRoute: typeof AppDevicesRoute
  AppInboxRoute: typeof AppInboxRoute
  AppKeysRoute: typeof AppKeysRoute
  AppLegalDocumentsRoute: typeof AppLegalDocumentsRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppOrgsRoute: typeof AppOrgsRoute
  AppOverviewRoute: typeof AppOverviewRoute
  AppPeopleRoute: typeof AppPeopleRoute
  AppPolicyRoute: typeof AppPolicyRoute
  AppSharingRoute: typeof AppSharingRoute
  AppStaffRolesRoute: typeof AppStaffRolesRoute
  AppTrailRoute: typeof AppTrailRoute
  AppYourLegalDocumentsRoute: typeof AppYourLegalDocumentsRoute
  AppLegalDocumentsDocumentIdRoute: typeof AppLegalDocumentsDocumentIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAllDevicesRoute: AppAllDevicesRoute,
  AppAllSharingRoute: AppAllSharingRoute,
  AppAuditRoute: AppAuditRoute,
  AppDeviceContentRoute: AppDeviceContentRoute,
  AppDevicesRoute: AppDevicesRoute,
  AppInboxRoute: AppInboxRoute,
  AppKeysRoute: AppKeysRoute,
  AppLegalDocumentsRoute: AppLegalDocumentsRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppOrgsRoute: AppOrgsRoute,
  AppOverviewRoute: AppOverviewRoute,
  AppPeopleRoute: AppPeopleRoute,
  AppPolicyRoute: AppPolicyRoute,
  AppSharingRoute: AppSharingRoute,
  AppStaffRolesRoute: AppStaffRolesRoute,
  AppTrailRoute: AppTrailRoute,
  AppYourLegalDocumentsRoute: AppYourLegalDocumentsRoute,
  AppLegalDocumentsDocumentIdRoute: AppLegalDocumentsDocumentIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  InviteRoute: InviteRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignInRoute: SignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
